export const GlobalVariable = {
    APPLICATION_NAME: 'Kindle Book Manager',  // Name of the App in the Authorization System

    API_BASE: 'https://steveking.mynetgear.com:2002',  // Production
    // API_BASE: 'https://localHost:2002', // Local Dev Container

    APP_BASE: 'https://steveking.mynetgear.com/kindle-mgr',

    AUTH_BASE: 'https://steveking.mynetgear.com:2001',
    //AUTH_BASE: 'https://localhost:2001',

    AMAZON_API_BASE: 'https://localhost:2062',

    ENVIRONMENT: "development",
    CAN_DEBUG: true
};
